import PropTypes from 'prop-types';
import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router';
import classNames from 'classnames';

import logo from '../../../../public/catch-logo.png';
import RegisterHotelForm from './RegisterHotelForm';

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(values) {
    const payload = values;
    this.props.registerPropertyAccount(payload);
  }
  render() {
    if (this.props.registered) {
      return (
        <div>
          <div className="container login">
            <div className="row">
              <div className="col-md-4 center-block">
                <div className="center-block-inner">
                  <img className="" src={logo} alt="Catch" />
                </div>
                <div style={{ padding: '60px 60px 60px 60px' }}>
                  <h4 className="text-left">Welcome to group travel simplified</h4>
                  <br />
                  <div className="login-container margin-top-medium">
                    Thanks for registering. Please verify your email to get started.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    let statusText = null;
    if (this.props.message) {
      statusText = (
        <div className="row">
          <div className="col-sm-12">
            <div className="alert-danger">{this.props.message}</div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="container login">
          <div className="row">
            <div className="col-md-4 center-block">
              <div className="center-block-inner">
                <img className="" src={logo} alt="Catch" />
              </div>
              <div style={{ padding: '60px 60px 60px 60px' }}>
                <h4 className="text-left">Welcome to group travel simplified</h4>
                <h4 className="text-left">Let's get your hotels on Catch.</h4>
                <br />
                <div className="login-container margin-top-medium">
                  {statusText}
                  <RegisterHotelForm onSubmit={this.handleSubmit} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Register.propTypes = {
  registerPropertyAccount: PropTypes.func.isRequired,
  registered: PropTypes.bool.isRequired,
  message: PropTypes.string,
};

export default Register;



// WEBPACK FOOTER //
// src/routes/hotels/components/Register.js